/**
 * Error codes shown on the error page so a specific failure condition can be
 * identified from a user's screenshot. See `docs/error_codes.md` for the
 * support-facing reference.
 *
 * Convention: `4xxxx` = request/input problem, `5xxxx` = backend communication
 * problem.
 */
const ErrorCodes = {
  /** `destination` query parameter was not provided. */
  DESTINATION_MISSING: 40001,
  /** `destination` could not be decoded/validated as a URL. */
  DESTINATION_INVALID: 40002,
  /** Uncaught render error, caught by the error boundary. */
  UNEXPECTED_ERROR: 40003,
  /** Failed to save (PUT) the user's policy agreements. */
  SAVE_AGREEMENTS_FAILED: 50001,
  /** Failed to load policies and outstanding agreements. */
  LOAD_POLICIES_FAILED: 50002,
} as const;

export default ErrorCodes;
